import React from 'react';
import { Turnstile, TurnstileInstance } from '@marsidev/react-turnstile';

import {
    TurnstileInnerBorderCover,
    TurnstileOuterBorderCover,
    TurnstileWrapper as StyledTurnstileWrapper,
    TurnstileOuterBorderCoverProps,
} from 'styles/turnstileWrapper';

interface TurnstileWrapperProps extends TurnstileOuterBorderCoverProps {
    turnstileRef: React.MutableRefObject<TurnstileInstance | undefined>;
    onSuccess: (token: string) => void;
}

export const TurnstileWrapper = ({
    turnstileRef,
    onSuccess,
    $color,
}: TurnstileWrapperProps) => {
    return (
        // Use multiple div overlays with individual border styling to mock a border radius
        // and border color following our design system since the Turnstile component
        // does not allow for custom styling
        <StyledTurnstileWrapper>
            <Turnstile
                ref={turnstileRef}
                siteKey="0x4AAAAAAAHdBQdhmUCPmC2X"
                onSuccess={onSuccess}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                onVerify={
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (token: any) => {
                        onSuccess(token);
                    }
                }
                options={{
                    theme: 'light',
                }}
            />
            <TurnstileOuterBorderCover $color={$color}>
                <TurnstileInnerBorderCover />
            </TurnstileOuterBorderCover>
        </StyledTurnstileWrapper>
    );
};
